import discountComparison from 'services/api/dashboards/discountComparison';
import executive from 'services/api/dashboards/executive';
import reserving from 'services/api/dashboards/reserving';

/**
 * Resource Endpoint.
 *
 * @type {String}
 */
export const RESOURCE = 'dashboards';

/**
 * Dashboard Resource Endpoints:
 *     - Executive
 */
export default {

    /**
     * Discount Rate Comparison Dashboard Endpoints.
     *
     * @type {}
     */
    discountComparison,

    /**
     * Executive Dashboard Endpoints.
     *
     * @type {}
     */
    executive,

    /**
     * Reserving Dashboard Endpoints.
     *
     * @type {}
     */
    reserving,
};



// WEBPACK FOOTER //
// ./src/services/api/dashboards.js